import React, { useRef, useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import queryString from "query-string";
import axios from "axios";
import {
  FormikForm,
  Section,
  AgGridDataTable,
  TonnageDisclaimer,
  Breadcrumbs,
} from "../../../shared";
import * as yup from "yup";
import ProgressComponenet from "../../../shared/utilities/ProgressComponent";
import urlParameterHelper from "../../../../utilities/urlParameters";

export default function HazardousWasteHandlerSummaryReport(props) {
  //first report
  const [manifestSummProgressPercentage, setManifestSummProgressPercentage] =
    useState(0);
  const [manifestSummprogressPercentage2, setManifestSummProgressPercentage2] =
    useState(0);
  const [manifestSummisLoading, setManifestSummIsLoading] = useState(false);
  const [manifestSummValue] = useState(Math.round(Math.random() * (44 - 20)) + 20);
  const [manifestSummstop, setManifestSummStop] = useState(false);

  //second report
  const [nonRcraProgressPercentage, setNonRcraProgressPercentage] = useState(0);
  const [nonRcraProgressPercentage2, setNonRcraProgressPercentage2] =
    useState(0);
  const [nonRcraIsLoading, setNonRcraIsLoading] = useState(false);
  const [nonRcraValue] = useState(Math.round(Math.random() * (44 - 20)) + 20);
  const [nonRcraStop, setNonRcraStop] = useState(false);
  // third report
  const [methodProgressPercentage, setMethodProgressPercentage] = useState(0);
  const [methodProgressPercentage2, setMethodProgressPercentage2] = useState(0);
  const [methodIsLoading, setMethodIsLoading] = useState(false);
  const [methodValue] = useState(Math.round(Math.random() * (44 - 20)) + 20);
  const [methodStop, setMethodStop] = useState(false);
  // forth report
  const [rcraProgressPercentage, setRcraProgressPercentage] = useState(0);
  const [rcraProgressPercentage2, setRcraProgressPercentage2] = useState(0);
  const [rcraIsLoading, setRcraIsLoading] = useState(false);
  const [rcraValue] = useState(Math.round(Math.random() * (44 - 20)) + 20);
  const [rcraStop, setRcraStop] = useState(false);

  const formRef = useRef();
  const history = useHistory();
  const location = useLocation();
  const params = queryString.parse(location.search);
  const searchOnInit = Object.keys(params).length > 0 ? true : false;
  const [hasSubmitted1, setHasSubmitted1] = useState(false);
  const [hasSubmitted2, setHasSubmitted2] = useState(false);
  const [hasSubmitted3, setHasSubmitted3] = useState(false);
  const [hasSubmitted5, setHasSubmitted5] = useState(false);
  const [initialFormValues] = useState({
    epaId: params && params.epaId ? params.epaId : "",
    siteType: params && params.siteType ? params.siteType : "",
    multishipYear:
      params && params.shipYear
        ? [{ value: params.shipYear, label: params.shipYear }]
        : [],
    fromDate: params && params.fromDate ? params.fromDate : "",
    toDate: params && params.toDate ? params.toDate : "",
  });

  const agGridRef1 = useRef();
  const [formParams, setFormParams] = useState([]);
  const [rowData1, setRowData1] = useState([]);
  const [api1IsFetching, setapi1IsFetching] = useState(false);
  const [columnDefs1, setColumnDefs1] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const agGridRef2 = useRef();
  const [rowData2, setRowData2] = useState([]);
  const [api2IsFetching, setapi2IsFetching] = useState(false);
  const [columnDefs2, setColumnDefs2] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const agGridRef3 = useRef();
  const [rowData3, setRowData3] = useState([]);
  const [api3IsFetching, setapi3IsFetching] = useState(false);
  const [columnDefs3, setColumnDefs3] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const agGridRef4 = useRef();
  const [rowData4, setRowData4] = useState([]);
  const [api4IsFetching, setapi4IsFetching] = useState(false);
  const [columnDefs4, setColumnDefs4] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const agGridRef5 = useRef();
  const [rowData5, setRowData5] = useState([]);
  const [api5IsFetching, setapi5IsFetching] = useState(false);
  const [columnDefs5, setColumnDefs5] = useState([
    {
      headerName: "",
      field: "",
    },
  ]);
  const apiEndpoint1 = "/api/v1/hwts/search/manifest/summary/epaid";
  const apiEndpoint2 = "/api/v1/hwts/search/tonnage/wastecode/ca";
  const apiEndpoint3 = "/api/v1/hwts/search/tonnage/disposal-method";
  const apiEndpoint4 = "/api/v1/hwts/search/tonnage/summary"; // no bar for this one
  const apiEndpoint5 = "/api/v1/hwts/search/tonnage/wastecode/rcra";
  const [source, setSource] = useState(axios.CancelToken.source());
  history.listen(() => {
    cancelCall();
  });
  const cancelCall = () => {
    source.cancel();
    setSource(axios.CancelToken.source());
  };

  const schema = yup.object({
    //   siteType: yup.string(),//.required("Site Type is required."),
    epaId: yup
      .string()
      .required("ID Number is required.")
      .min(12, "ID Number requires a min length of 12."),
    multishipYear: yup
      .string()
      .when(["fromDate"], {
        is: (fromDate) => !fromDate,
        then: yup
          .string()
          .required("Either Shipment Dates or Ship Year is required."),
      })
      .when(["toDate"], {
        is: (toDate) => !toDate,
        then: yup
          .string()
          .required("Either Shipment Dates or Ship Year is required."),
      }),
  });
  const formConfig = [
    {
      name: "epaId",
      config: {
        col: "md",
        colWidth: "3",
        label: "ID Number",
        placeholder: "Enter an ID Number...",
        type: "text",
      },
    },
    {
      name: "siteType",
      config: {
        col: "md",
        colWidth: "2",
        label: "Handler Type",
        placeholder: "Select a Waste Code",
        type: "select3",
        data: [
          {
            label: "Generator",
            value: "Generator",
          },
          {
            label: "Transporter",
            value: "Transporter",
          },
          {
            label: "TSDF",
            value: "TSDF",
          },
        ],
      },
    },
    {
      name: "multishipYear",
      config: {
        col: "md",
        validate: true,
        colWidth: "3",
        label: "Select a Year",
        placeholder: "Select a Year",
        type: "multi-select",
        apiEndpoint: "/api/v1/hwts/search/ship-years",
        hasApi: true,
      },
    },
    {
      name: "fromDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Ship From Date",
        placeholder: "",
        type: "date",
      },
    },
    {
      name: "toDate",
      config: {
        col: "md",
        colWidth: "2",
        label: "Ship To Date",
        placeholder: "",
        type: "date",
      },
    },
  ];

  const customGridCells = [
    {
      columnName: "Total_Manifests",
      cellRenderer: function (params) {
        if (params.value != null) {
          return (
            `<a href="/reports/manifest?epaId=${params.data.epaSiteId}&shipYear=${params.data.Ship_Year}&entityType=${params.data.siteType}" target="_">` +
            params.value +
            "</a>"
          );
        }
      },
    },
    {
      columnName: "epaSiteId",
    },
    {
      columnName: "siteType",
    },
    {
      columnName: "FacName",
    },
  ];

  const setAgGrid1 = (data) => {
    let columnsArr = data[0];
    let colDefArr = [];
    Object.keys(columnsArr).forEach((col) => {
      if (customGridCells) {
        var cellRend = customGridCells.filter(
          (object) => object.columnName === col
        );
        if (cellRend.length > 0) {
          colDefArr.push({
            headerName: col.replace(/_/g, " "),
            field: col,
            sortable: true,
            hide: col.includes("Total_Manifests") ? false : true,
            cellRenderer: cellRend[0].cellRenderer,
          });
        } else {
          if (col === "Non_RCRA_Tons") {
            colDefArr.push({
              headerName: "Non-RCRA Tons",
              field: col,
              sortable: true,
              hide: false,
            });
          } else {
            colDefArr.push({
              headerName: col.replace(/_/g, " "),
              field: col,
              sortable: true,
            });
          }
        }
      } else {
        colDefArr.push({
          headerName: col.replace(/_/g, " "),
          field: col,
          sortable: true,
        });
      }
    });

    setColumnDefs1(colDefArr);
    setRowData1(data);
  };
  const setAgGrid2 = (data) => {
    let columnsArr = data[0];
    let colDefArr = Object.keys(columnsArr).map((col) => {
      return ({
        headerName: col.replace(/_/g, " "),
        field: col,
        sortable: true,
      });
    });

    setColumnDefs2(colDefArr);
    setRowData2(data);
  };
  const setAgGrid3 = (data) => {
    let columnsArr = data[0];
    let colDefArr = Object.keys(columnsArr).map((col) => {
      return ({
        headerName: col.replace(/_/g, " "),
        field: col,
        sortable: true,
      });
    });

    setColumnDefs3(colDefArr);
    setRowData3(data);
  };

  const setAgGrid4 = (data) => {
    let columnsArr = data[0];
    let colDefArr = Object.keys(columnsArr).map((col) => {
      return ({
        headerName: col.replace(/_/g, " "),
        field: col,
        sortable: true,
      });
    });

    setColumnDefs4(colDefArr);
    setRowData4(data);
  };

  const setAgGrid5 = (data) => {
    let columnsArr = data[0];
    let colDefArr = Object.keys(columnsArr).map((col) => {
      return ({
        headerName: col.replace(/_/g, " "),
        field: col,
        sortable: true,
      });
    });

    setColumnDefs5(colDefArr);
    setRowData5(data);
  };

  const callApi1 = async (qs, formik) => {
    setManifestSummIsLoading(true); // calling the progress bar
    let value = 100;
    setapi1IsFetching(true);
    axios
      .get(`${apiEndpoint1}?${qs}`, {
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (percentCompleted > 90) {
            setManifestSummProgressPercentage2(
              value >= 100 ? value - 1 : value++
            );
            setManifestSummStop(true);
          }
        },
      })
      .then((res) => {
        setManifestSummStop(false);
        if (res.data.length === 0) {
          setColumnDefs1([
            {
              headerName: "",
              field: "",
            },
          ]);
          setRowData1([]);

          agGridRef1.current.api.showNoRowsOverlay();
        } else {
          setAgGrid1(res.data);
          agGridRef1.current.api.hideOverlay();
        }
        setapi1IsFetching(false);
        setHasSubmitted1(true);
        agGridRef1.current.api.sizeColumnsToFit();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      })
      .then(async () => {
        setManifestSummIsLoading(false);
      })
      .catch((err) => {
        setManifestSummIsLoading(false);
        if (axios.isCancel(err)) {
          console.log("Axios Request canceled", err.message);
        } else if (err.response && err.response.status === 400) {
          let requiredFields = {};

          Object.keys(err.response.data).forEach((key, i) => {
            requiredFields = {
              ...requiredFields,
              [key]: err.response.data[key][0],
            };
          });

          formik.setErrors(requiredFields);
        }
        setColumnDefs1([
          {
            headerName: "",
            field: "",
          },
        ]);
        setRowData1([]);
        setapi1IsFetching(false);
        setHasSubmitted1(true);
        agGridRef1.current.api.showNoRowsOverlay();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      });
  };

  const callApi2 = async (qs, formik) => {
    setNonRcraIsLoading(true);
    let value = 100;
    setapi2IsFetching(true);
    axios
      .get(`${apiEndpoint2}?${qs}`, {
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (percentCompleted > 90) {
            setNonRcraProgressPercentage2(value >= 100 ? value - 2 : value++);
            setNonRcraStop(true);
          }
        },
      })
      .then((res) => {
        setNonRcraStop(false);
        if (res.data.length === 0) {
          setColumnDefs2([
            {
              headerName: "",
              field: "",
            },
          ]);
          setRowData2([]);

          agGridRef2.current.api.showNoRowsOverlay();
        } else {
          setAgGrid2(res.data);
          agGridRef2.current.api.hideOverlay();
        }
        setapi2IsFetching(false);
        setHasSubmitted2(true);
        agGridRef2.current.api.sizeColumnsToFit();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      })
      .then(async () => {
        setNonRcraIsLoading(false);
      })
      .catch((err) => {
        setNonRcraIsLoading(false);
        if (axios.isCancel(err)) {
          console.log("Axios Request canceled", err.message);
        } else if (err.response && err.response.status === 400) {
          let requiredError = err.response.data.error;
          let message = err.response.data.message;

          let requiredFieldsArr = err.response.data.required;
          let requiredFields = {};

          requiredFieldsArr.forEach((field) => {
            requiredFields = {
              ...requiredFields,
              [field]: (requiredError === 2) ? message : `${field} is required.`,
            };
          });

          formik.setErrors(requiredFields);
        }
        setColumnDefs2([
          {
            headerName: "",
            field: "",
          },
        ]);
        setRowData2([]);
        setapi2IsFetching(false);
        setHasSubmitted2(true);
        agGridRef2.current.api.showNoRowsOverlay();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      });
  };
  const callApi3 = async (qs, formik) => {
    setMethodIsLoading(true);
    let value = 100;
    setapi3IsFetching(true);
    axios
      .get(`${apiEndpoint3}?${qs}`, {
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (percentCompleted > 90) {
            setMethodProgressPercentage2(value >= 100 ? value - 1 : value++);
            setMethodStop(true);
          }
        },
      })
      .then((res) => {
        setMethodStop(false);
        if (res.data.length === 0) {
          setColumnDefs3([
            {
              headerName: "",
              field: "",
            },
          ]);
          setRowData3([]);

          agGridRef3.current.api.showNoRowsOverlay();
        } else {
          setAgGrid3(res.data);
          agGridRef3.current.api.hideOverlay();
        }
        setapi3IsFetching(false);
        setHasSubmitted3(true);
        agGridRef3.current.api.sizeColumnsToFit();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      })
      .then(async () => {
        setMethodIsLoading(false);
      })
      .catch((err) => {
        setMethodIsLoading(false);
        if (axios.isCancel(err)) {
          console.log("Axios Request canceled", err.message);
        } else if (err.response && err.response.status === 400) {
          let requiredError = err.response.data.error;
          let message = err.response.data.message;

          let requiredFieldsArr = err.response.data.required;
          let requiredFields = {};

          requiredFieldsArr.forEach((field) => {
            requiredFields = {
              ...requiredFields,
              [field]: (requiredError === 2) ? message : `${field} is required.`,
            };
          });
          formik.setErrors(requiredFields);
        }
        setColumnDefs3([
          {
            headerName: "",
            field: "",
          },
        ]);
        setRowData3([]);
        setapi3IsFetching(false);
        setHasSubmitted3(true);
        agGridRef3.current.api.showNoRowsOverlay();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      });
  };

  const callApi4 = async (qs, formik) => {
    setapi4IsFetching(true);
    setRowData4([]);
    axios
      .get(`${apiEndpoint4}?${qs}`, {
        cancelToken: source.token,
      })
      .then((res) => {
        if (res.data.length === 0) {
          setColumnDefs4([
            {
              headerName: "",
              field: "",
            },
          ]);
          setRowData4([]);

          //   agGridRef4.current.api.showNoRowsOverlay();
        } else {
          setAgGrid4(res.data);
          // agGridRef4.current.api.hideOverlay();
        }
        setapi4IsFetching(false);
        //agGridRef4.current.api.sizeColumnsToFit();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      })

      .catch((err) => {
        if (axios.isCancel(err)) {
          console.log("Axios Request canceled", err.message);
        } else if (err.response && err.response.status === 400) {
          let requiredFields = {};

          Object.keys(err.response.data).forEach((key, i) => {
            requiredFields = {
              ...requiredFields,
              [key]: err.response.data[key][0],
            };
          });

          formik.setErrors(requiredFields);
        }
        setColumnDefs4([
          {
            headerName: "",
            field: "",
          },
        ]);
        setRowData4([]);
        setapi4IsFetching(false);
        agGridRef4.current.api.showNoRowsOverlay();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      });
  };

  const callApi5 = async (qs, formik) => {
    setRcraIsLoading(true);
    let value = 100;
    setapi5IsFetching(true);
    axios
      .get(`${apiEndpoint5}?${qs}`, {
        cancelToken: source.token,
        onDownloadProgress: (progressEvent) => {
          let percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );

          if (percentCompleted > 90) {
            setRcraProgressPercentage2(value >= 100 ? value - 1 : value++);
            setRcraStop(true);
          }
        },
      })

      .then((res) => {
        setRcraStop(false);
        if (res.data.length === 0) {
          setColumnDefs5([
            {
              headerName: "",
              field: "",
            },
          ]);
          setRowData5([]);

          agGridRef5.current.api.showNoRowsOverlay();
        } else {
          setAgGrid5(res.data);
          agGridRef5.current.api.hideOverlay();
        }
        setapi5IsFetching(false);
        setHasSubmitted5(true);
        agGridRef5.current.api.sizeColumnsToFit();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      })
      .then(async () => {
        setRcraIsLoading(false);
      })
      .catch((err) => {
        setRcraIsLoading(false);
        if (axios.isCancel(err)) {
          console.log("Axios Request canceled", err.message);
        } else if (err.response && err.response.status === 400) {
          let requiredError = err.response.data.error;
          let message = err.response.data.message;

          let requiredFieldsArr = err.response.data.required;
          let requiredFields = {};

          requiredFieldsArr.forEach((field) => {
            requiredFields = {
              ...requiredFields,
              [field]: (requiredError === 2) ? message : `${field} is required.`,
            };
          });

          formik.setErrors(requiredFields);
        }
        setColumnDefs5([
          {
            headerName: "",
            field: "",
          },
        ]);
        setRowData5([]);
        setapi5IsFetching(false);
        setHasSubmitted5(true);
        agGridRef5.current.api.showNoRowsOverlay();
        if (
          api1IsFetching === false &&
          api2IsFetching === false &&
          api3IsFetching === false &&
          api4IsFetching === false &&
          api5IsFetching === false
        )
          formik.setSubmitting(false);
      });
  };

  const search = async (formData, formik) => {
    let obj = {};
    Object.keys(formData).forEach((key) => {
      if (formData[key] !== "") {
        obj[key] = formData[key];
      }
    });

    const qs = urlParameterHelper.stringify(obj);
    window.history.replaceState(null, 'Hazardous Waste Tracking System', `${location.pathname}?${qs}`);

    await callApi4(qs, formik);
    await callApi1(qs, formik);
    await callApi2(qs, formik);
    await callApi3(qs, formik);
    await callApi5(qs, formik);

    agGridRef1.current.api.showLoadingOverlay();
    agGridRef2.current.api.showLoadingOverlay();
    agGridRef3.current.api.showLoadingOverlay();
    agGridRef5.current.api.showLoadingOverlay();

    setFormParams(formData);
  };

  const onSubmit = async (formData, formik) => {
    Object.keys(formData).forEach((key) => {
      if (key.startsWith("multi")) {
        let object = formData[key].map((c) => c.value).join(",");
        let name = key.substring(5); // removes "multi" from the start
        formData[name] = object;
      }
    });
    search(formData, formik);
  };

  useEffect(() => {
    if (searchOnInit) {
      setTimeout(() => formRef.current.submitForm());
    }
  }, [searchOnInit]);

  return (
    <React.Fragment>
      <Section title="Hazardous Waste Handler Summary" type={"standout"} />
      <div id="page-container" className="container" style={{ position: "relative" }}>
        <Breadcrumbs
          breadcrumbs={[
            { name: "HWTS Reports", url: "/reports", active: false },
            { name: "View Handler Summary", url: "", active: true },
          ]}
        />
        <FormikForm
          initialFormValues={initialFormValues}
          schema={schema}
          formConfig={formConfig}
          onSubmit={onSubmit}
          formRef={formRef}
          cancelCall={cancelCall}
        />

        {rowData1[0] ? (
          <h2
            style={{
              textAlign: "center",
            }}
          >
            {rowData1[0].epaSiteId} - {rowData1[0].FacName}
          </h2>
        ) : null}

        <h3
          style={{
            textAlign: "center",
          }}
        >
          Manifest Summary
        </h3>
        <ProgressComponenet
          percent={manifestSummProgressPercentage}
          setProgressPercentage={setManifestSummProgressPercentage}
          percent2={manifestSummprogressPercentage2}
          grid={true}
          isLoading={manifestSummisLoading}
          value={manifestSummValue}
          stop={manifestSummstop}
        />
        <AgGridDataTable
          agGridRef={agGridRef4}
          columnDefs={columnDefs4}
          rowData={rowData4}
          initialPageSize={50}
          pageTitle="ManifestSummary"
          formConfig={formConfig}
          formParams={formParams}
          hidePagination={true}
          csvOnly={true}
          hideRecordCnt={true}
        />
        <AgGridDataTable
          agGridRef={agGridRef1}
          columnDefs={columnDefs1}
          rowData={rowData1}
          initialPageSize={50}
          pageTitle="ManifestSummary"
          formConfig={formConfig}
          formParams={formParams}
          hideCsvExport={true}
          hideRecordCnt={true}
        />
        <h3
          style={{
            textAlign: "center",
          }}
        >
          Non-RCRA Waste Summary
        </h3>
        <br />
        <ProgressComponenet
          percent={nonRcraProgressPercentage}
          setProgressPercentage={setNonRcraProgressPercentage}
          percent2={nonRcraProgressPercentage2}
          grid={true}
          isLoading={nonRcraIsLoading}
          value={nonRcraValue}
          stop={nonRcraStop}
        />
        <br />

        <div
          style={{ fontSize: "1rem", fontStyle: "italic", textAlign: "center" }}
        >
          Disclaimer: The sum of the quantities may exceed the total tonnage
          because a manifest waste stream may contain multiple waste codes.
        </div>
        <AgGridDataTable
          agGridRef={agGridRef2}
          columnDefs={columnDefs2}
          rowData={rowData2}
          initialPageSize={50}
          pageTitle="NonRCRAWasteSummary"
          formConfig={formConfig}
          formParams={formParams}
          hideCsvExport={true}
          hideRecordCnt={true}
        />
        <h3
          style={{
            textAlign: "center",
          }}
        >
          RCRA Waste Summary
        </h3>
        <br />
        <ProgressComponenet
          percent={methodProgressPercentage}
          setProgressPercentage={setMethodProgressPercentage}
          percent2={methodProgressPercentage2}
          grid={true}
          isLoading={methodIsLoading}
          value={methodValue}
          stop={methodStop}
        />
        <br />
        <div
          style={{ fontSize: "1rem", fontStyle: "italic", textAlign: "center" }}
        >
          Disclaimer: The sum of the quantities may exceed the total tonnage
          because a manifest waste stream may contain multiple waste codes.
        </div>
        <AgGridDataTable
          agGridRef={agGridRef5}
          columnDefs={columnDefs5}
          rowData={rowData5}
          initialPageSize={50}
          pageTitle="RCRAWasteSummary"
          formConfig={formConfig}
          formParams={formParams}
          hideCsvExport={true}
          hideRecordCnt={true}
        />
        <h3
          style={{
            textAlign: "center",
          }}
        >
          Disposal Method Summary
        </h3>
        <br />
        <ProgressComponenet
          percent={rcraProgressPercentage}
          setProgressPercentage={setRcraProgressPercentage}
          percent2={rcraProgressPercentage2}
          grid={true}
          isLoading={rcraIsLoading}
          value={rcraValue}
          stop={rcraStop}
        />
        <br />
        <AgGridDataTable
          agGridRef={agGridRef3}
          columnDefs={columnDefs3}
          rowData={rowData3}
          initialPageSize={50}
          pageTitle="DisposalMethodSummary"
          formConfig={formConfig}
          formParams={formParams}
          hideCsvExport={true}
          hideRecordCnt={true}
        />
        <div className="m-b-md"></div>
        <TonnageDisclaimer />
      </div>
    </React.Fragment>
  );
}
